// eslint-disable-next-line import/prefer-default-export
export const testAttributes = {
    MORTGAGE_CHECKBOX_CONTAINER: 'mortgage_checkbox_container',
    MORTGAGE_CHECKBOX: 'mortgage_checkbox_',
};
export const CHECKBOX_DEFAULT_VALUE = 'on';